export default "__VITE_ASSET__a52afb62__"